/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';

import AppointmentCardPopup from '../../components/timetable/AppointmentCardPopup';

const mapStateToProps = ({ user }) => ({
    salonId: user.get('salon'),
});

// Handle popup visibility state to skip request while it's closed yet
function AppointmentCardPopupContainer(props) {
    const [open, setOpen] = useState(false);

    const onOpen = useCallback(() => {
        setOpen(true);
    }, []);

    const onClose = useCallback(() => {
        // tricky thing - calling setOpen(false) synchronously makes the target
        // popup disappear but eventually closes all other popups/modals (?), so
        // defer it a tick.
        setTimeout(() => setOpen(false), 0);
    }, []);

    return (
        <AppointmentCardPopup
            {...props}
            open={open}
            onOpen={onOpen}
            onClose={onClose}
        />
    );
}

export default connect(mapStateToProps)(AppointmentCardPopupContainer);
